// extracted by mini-css-extract-plugin
export default {"belowHeaderText":"auth__belowHeaderText__qQC4Xk"};